import { BaseStorage } from './base-storage.storage';

export class LocalStorage extends BaseStorage {
  /**
   * Load item from storage.
   * It returns null, if key does not exist in the storage.
   *
   * @param key
   */
  public getItem(key: string): string | null {
    return window.localStorage.getItem(key);
  }

  /**
   * Check if storage has item with key.
   *
   * @param key
   */
  public hasItem(key: string): boolean {
    return window.localStorage.getItem(key) !== null;
  }

  /**
   * Remove item from storage.
   * If key does not exist, this do nothing.
   *
   * @param key
   */
  public removeItem(key: string): void {
    window.localStorage.removeItem(key);
  }

  /**
   * Clear whole storage.
   */
  public clear(): void {
    window.localStorage.clear();
  }

  /**
   * Return storage identifier.
   */
  public getIdentifier(): string {
    return 'local-storage';
  }

  /**
   * For saving the (key, value) to the storage place - used in setItem.
   *
   * @param key
   * @param value
   */
  protected saveItem(key: string, value: string): void {
    window.localStorage.setItem(key, value);
  }
}
